import { createSelector } from '@ngrx/store';

import { getOrderState } from '../order.selector';

export const getOrderCustomerTypeState = createSelector(
  getOrderState,
  (state) => state?.orderCustomerType
);

export const getOrderCustomerTypeProgressiveFormState = createSelector(
  getOrderState,
  (state) => state?.orderCustomerType?.progressiveForm
);

export const getOrderCustomerTypeFormState = createSelector(
  getOrderCustomerTypeProgressiveFormState,
  (state) => state?.formState
);
